import { type FC, useEffect } from 'react';
import styles from '../styles/date-selection.module.scss';
import BlueCard from '../components/blue-card';
import DayPicker from '../components/day-picker';
import AttentionNotice from '../components/attention-notice';
import ActionButton from '../components/action-button';
import PageTitle from '../components/page-title';
import useAppointments from '../hooks/use-appointments';
import type { AppointmentListResponse, AppointmentSlot } from '../models/repair-bookings';
import { getTimeSlotString } from '../utils/helpers';

type DateSelectionProps = {
    selectedSlot: AppointmentSlot | null;
    fetchTimeSlots: () => Promise<AppointmentListResponse>;
    onComplete: (date: string, slots: AppointmentSlot[]) => void;
    onCancel: () => void;
};

const DateSelection: FC<DateSelectionProps> = (props) => {
    const { dayOptions, timeOptions, error, loading, getSlot, getSlotsInRange } = useAppointments(
        props.fetchTimeSlots
    );

    useEffect(() => {
        if (error) {
            alert(error.message);
        }
    }, [error]);

    return (
        <div className={styles.dateSelection}>
            {props.selectedSlot && (
                <BlueCard className={styles.timeCard}>
                    <div className={styles.timeHeader}>＜予約日時情報＞</div>
                    <div className={styles.timeInfo}>{getTimeSlotString(props.selectedSlot)}</div>
                </BlueCard>
            )}
            {loading ? (
                <p data-loading-message role="status" aria-live="polite">
                    店舗の空き情報を確認しています
                </p>
            ) : dayOptions.length > 0 ? (
                <>
                    <PageTitle title="ご希望の日付と時間帯を選択してください" />
                    <DayPicker
                        className={styles.dayPicker}
                        dayOptions={dayOptions}
                        timeOptions={timeOptions}
                        isAvailable={(rawDate, time) => getSlot(rawDate, time) != null}
                        onRangeSelect={(rawDate, time) =>
                            props.onComplete(rawDate, getSlotsInRange(rawDate, time))
                        }
                    />
                    <AttentionNotice
                        messages={['○：予約可　×：予約不可']}
                        note="※ 混雑状況により、ご予約時間に対応できない場合がございます。あらかじめご了承ください。"
                    />
                </>
            ) : (
                <p>現在予約可能な日程がありません</p>
            )}
            <ActionButton
                className={styles.backButton}
                title="戻る"
                primary={false}
                onClick={props.onCancel}
            />
        </div>
    );
};

export default DateSelection;
